var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 19.586L27.0001 15",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23C22.1046 23 23 22.1046 23 21C23 19.8954 22.1046 19 21 19C19.8954 19 19 19.8954 19 21C19 22.1046 19.8954 23 21 23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 21C40 10.507 31.493 2 21 2",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6V8",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6069 10.393L30.1919 11.808",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 11.808L10 10.393",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21H34",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21H6",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 21C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSize);
export default __webpack_public_path__ + "static/media/fontSize.53724561a9550484e9f9207e4a386970.svg";
export { ForwardRef as ReactComponent };